export const FETCH_QUESTIONS = "FETCH_QUESTIONS";
export const FETCH_QUESTIONS_SUCCESS = "FETCH_QUESTIONS_SUCCESS";
export const FETCH_QUESTIONS_FAILURE = "FETCH_QUESTIONS_FAILURE";

export const FETCH_QUESTION = "FETCH_QUESTION";
export const FETCH_QUESTION_SUCCESS = "FETCH_QUESTION_SUCCESS";
export const FETCH_QUESTION_FAILURE = "FETCH_QUESTION_FAILURE";

export const CREATE_QUESTION = "CREATE_QUESTION";
export const CREATE_QUESTION_SUCCESS = "CREATE_QUESTION_SUCCESS";
export const CREATE_QUESTION_FAILURE = "CREATE_QUESTION_FAILURE";

export const UPDATE_QUESTION = "UPDATE_QUESTION";
export const UPDATE_QUESTION_SUCCESS = "UPDATE_QUESTION_SUCCESS";
export const UPDATE_QUESTION_FAILURE = "UPDATE_QUESTION_FAILURE";

export const DELETE_QUESTION = "DELETE_QUESTION";
export const DELETE_QUESTION_SUCCESS = "DELETE_QUESTION_SUCCESS";
export const DELETE_QUESTION_FAILURE = "DELETE_QUESTION_FAILURE";

export const UPLOAD_QUESTIONS = "UPLOAD_QUESTIONS";
export const UPLOAD_QUESTIONS_SUCCESS = "UPLOAD_QUESTIONS_SUCCESS";
export const UPLOAD_QUESTIONS_FAILURE = "UPLOAD_QUESTIONS_FAILURE";

export const COUNT_QUESTIONS = "COUNT_QUESTIONS";
export const COUNT_QUESTIONS_SUCCESS = "COUNT_QUESTIONS_SUCCESS";
export const COUNT_QUESTIONS_FAILURE = "COUNT_QUESTIONS_FAILURE";

export const RESET_QUESTION = "RESET_QUESTION";
